export const transformRetentionDataToSeriesLog = (reportData) => {
    if (!reportData || !Array.isArray(reportData)) {
        return {
            categories: [],
            series    : []
        };
    }
    
    const categories = reportData.map(item => {
        const date = new Date(item.date);
        return date.toLocaleDateString("en-US", { 
            month: "short", 
            day  : "numeric" 
        });
    });
    
    const expansionData = [];
    const churnData = [];
    const contractionData = [];
    
    reportData.forEach(item => {
        expansionData.push(item.expansion_revenue || 0);
        churnData.push(item.churn_revenue || 0);
        contractionData.push(item.contraction_revenue || 0);
    });
    
    return {
        categories,
        series: [
            {
                name : "Expansion Revenue",
                data : expansionData,
                color: "#bfdbfe"
            },
            {
                name : "Churn Revenue",
                data : churnData,
                color: "#fecaca"
            },
            {
                name : "Contraction Revenue",
                data : contractionData,
                color: "#fde68a"
            }
        ],
        chartOptions: {
            chart: {
                type: "column"
            },
            yAxis: {
                type : "logarithmic",
                title: {
                    text: "Revenue"
                },
                min: 0.1 
            }
        }
    };
};